module.exports = __webpack_public_path__ + "fonts/Raleway-BlackItalic.c7c942b6.ttf";